import * as Stimulus from "@hotwired/stimulus"

export class TsidDecoderController extends Stimulus.Controller {
    static get targets() {
        return ['content'];
    }

    handleKeydown(e) {
        if (e.ctrlKey && e.key === ';') {
            e.preventDefault();
            this.open();
        }
        if (e.key === 'Escape' && this.element.open) {
            this.close();
        }
    }

    async open() {
        const tsidEntries = this.extractTsidsFromUrl();
        if (tsidEntries.length === 0) {
            this.renderEmpty();
        } else {
            this.renderLoading();
            const tsids = tsidEntries.map(e => e.tsid);
            const labelMap = Object.fromEntries(tsidEntries.map(e => [e.tsid, e.label]));
            const results = await this.decodeTsids(tsids);
            this.renderResults(results, labelMap);
        }
        this.element.showModal();
    }

    close() {
        this.element.close();
    }

    closeIfClickedOutside(e) {
        if (e.target === this.element && this.element.open) {
            this.close();
        }
    }

    extractTsidsFromUrl() {
        const path = window.location.pathname;
        const segments = path.split('/').filter(s => s.length > 0);
        // Crockford Base32: 0-9, A-H, J-K, M-N, P-T, V-Z (no I, L, O, U)
        const tsidPattern = /^[0-9a-hjkmnp-tv-z]{12,13}$/i;

        const results = [];
        for (let i = 0; i < segments.length; i++) {
            if (tsidPattern.test(segments[i])) {
                results.push({
                    tsid: segments[i],
                    label: i > 0 ? segments[i - 1] : null
                });
            }
        }
        return results;
    }

    async decodeTsids(tsids) {
        const response = await fetch('/admin/tsid/decode', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(tsids)
        });
        return response.json();
    }

    renderLoading() {
        this.contentTarget.innerHTML = '<p class="text-gray-500">Decoding...</p>';
    }

    renderEmpty() {
        this.contentTarget.innerHTML = `
            <p class="text-gray-500 italic">No TSIDs found in the current URL.</p>
            <p class="text-sm text-gray-400 mt-2">TSIDs are 13-character Crockford Base32 encoded identifiers.</p>
        `;
    }

    renderResults(results, labelMap) {
        const rows = results.map(r => {
            const label = labelMap[r.tsid];
            const header = label
                ? `<span class="text-gray-400">${label} /</span> ${r.tsid}`
                : r.tsid;

            if (r.error) {
                return `<div class="border rounded p-3 bg-red-50">
                    <div class="font-mono text-sm">${header}</div>
                    <div class="text-red-600 text-sm">${r.error}</div>
                </div>`;
            }
            return `<div class="border rounded p-3 bg-gray-50">
                <div class="font-mono text-sm text-gray-600">${header}</div>
                <div class="grid grid-cols-2 gap-2 mt-2 text-sm">
                    <div>
                        <span class="text-gray-500">Integer:</span>
                        <input name="tsid-integer" type="text" readonly value="${r.integer}" class="font-mono font-bold bg-transparent border-none p-0 cursor-text" style="width: ${String(r.integer).length}ch" />
                    </div>
                    <div>
                        <span class="text-gray-500">Created:</span>
                        <span class="font-mono">${new Date(r.timestamp).toLocaleString()}</span>
                    </div>
                </div>
            </div>`;
        }).join('');
        this.contentTarget.innerHTML = rows;
    }
}
